import {useTranslation as useTranslationi18n} from 'react-i18next'
import {useSelector} from 'react-redux'

import {AppState} from '../App.reducer'

export const useTranslation = () => {
  const namespace = useSelector((state: AppState) => state?.adminConsoleLocalizationNamespace)
  return useTranslationi18n(namespace)
}